/**
 * Mainbeauty — hành vi chung của popup có form đăng ký (.popov).
 */

/** Có lớp phủ nào đang mở không — popup TỰ ĐỘNG hỏi câu này trước khi bật. */
export function isAnyPopupOpen() {
  return document.querySelector(".popov.is-open") !== null;
}

/** Popup tự động nhường chỗ cho popup do người dùng bấm ra. */
export function closeAutoPopup() {
  // 🚨 Chỉ gỡ is-open: popup tự động không đặt .pi-noscroll, close() ở đây sẽ gỡ khoá cuộn của popup đang mở.
  const auto = document.querySelector("[data-pi-popup].is-open");
  if (auto) auto.classList.remove("is-open");
}

/**
 * Đưa con trỏ vào ô đầu tiên — CHỈ trên thiết bị có chuột.
 *
 * 🚨 Trên mobile, focus lúc mở popup bật luôn bàn phím ảo: nó che mất tiêu đề và phân nửa form,
 * người dùng chưa kịp đọc popup nói gì. Bàn phím phải do người dùng gọi ra.
 */
export function focusFirstField(popup) {
  if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
  const first = popup.querySelector(".pi-form__body .inp");
  if (first) first.focus();
}

/** Trả form trong popup về trạng thái nhập liệu. */
function resetLeadForm(popup) {
  const form = popup.querySelector("[data-pi-form]");
  if (!form) return;
  const body = form.querySelector(".pi-form__body");
  const sent = form.querySelector("[data-pi-sent]");
  if (body) body.hidden = false;
  if (sent) sent.hidden = true;
  form.reset();
}

/** Gửi xong thì popup tự đóng, nhường chỗ cho modal thông báo chung. */
export function closePopupOnLead(popup, close) {
  document.addEventListener("pi:lead", () => {
    if (!popup.classList.contains("is-open")) return;
    close();
    setTimeout(() => resetLeadForm(popup), 300); // sau transition fade-out
  });
}

/** Nút đóng luôn ăn; bấm ra ngoài khung CHỈ đóng khi popup không có nút đóng. */
export function bindPopupClose(popup, boxSelector, closeSelector, close) {
  popup.addEventListener("click", (e) => {
    if (e.target.closest(closeSelector)) {
      close();
      return;
    }
    if (popup.querySelector(closeSelector)) return;
    const box = popup.querySelector(boxSelector);
    if (box && !box.contains(e.target)) close();
  });
}
